module.exports = __webpack_public_path__ + "img/a19f0d6.png";